import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=ad12757e&scoped=true&"
import script from "./ViewForm.vue?vue&type=script&lang=ts&"
export * from "./ViewForm.vue?vue&type=script&lang=ts&"
import style0 from "./ViewForm.vue?vue&type=style&index=0&id=ad12757e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad12757e",
  null
  
)

export default component.exports